<template>
  <v-container class="welcome" fill-height>
    <img
      src="@/assets/img/logos/99icon_black.svg"
      class="welcome__logo"
      :alt="appName"
      :title="appName"
    >

    <v-container fill-height>
      <v-layout align-center justify-center row wrap>
        <v-flex md6 sm12 xs12>
          <h1 class="welcome__title">{{ $t(`${namespace}.title`) }}</h1>
          <h2 class="welcome__subtitle">{{ $t(`${namespace}.subtitle`) }}</h2>
          <p class="welcome__text">{{ $t(`${namespace}.paragraph`) }}</p>
          <p class="welcome__text">
            <strong>{{ $t(`${namespace}.letsStart`) }}</strong>
          </p>

          <div class="welcome__actions">
            <v-btn
              :to="{
                name: 'CostCenter',
                params: { type: 'cadastrar' }
              }"
              color="warning--gradient"
              rounded
              block
              depressed
              large
            >
              {{ $t(`${namespace}.buttonLabel`) }}
            </v-btn>

            <div class="mt-2">
              <a
                class="accent--text"
                :title="$t(`${namespace}.skip`)"
                @click.prevent="skip"
              >
                {{ $t(`${namespace}.skip`) }}
              </a>
            </div>
          </div>

          <v-checkbox
            v-model="disabled"
            :label="$t(`${namespace}.checkbox`)"
            color="primary"
            on-icon="check_box"
            off-icon="check_box_outline_blank"
            hide-details
          />
        </v-flex>

        <v-flex md6 sm12 xs12>
          <img class="welcome__img" src="@/assets/img/illustrations/business.svg" alt="">
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import { SESSION_WELCOME } from 'utils/constants'

export default {
  name: 'WelcomePage',
  computed: {
    appName () {
      return process.env.VUE_APP_TITLE
    }
  },
  data () {
    return {
      namespace: 'Views.WelcomePage',
      disabled: false
    }
  },
  methods: {
    skip () {
      this.$router.push('/')
    },

    toggleWelcomeStoreItem (val) {
      val
        ? localStorage.setItem(SESSION_WELCOME, val)
        : localStorage.removeItem(SESSION_WELCOME)
    }
  },
  watch: {
    disabled (val) {
      this.toggleWelcomeStoreItem(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.welcome {
  max-width: 880px;
  margin: 0 auto;
  padding: 130px 16px 32px;
  position: relative;

  @media (min-width: 960px) {
    padding-top: 96px;
  }
}

.welcome__logo {
  left: 50%;
  margin-left: -32px;
  position: fixed;
  top: 30px;
  z-index: 4;
}

.welcome__title,
.welcome__subtitle {
  color: $gray-7;
  font-family: $title-font;
}

.welcome__title {
  font-size: 24px;
  font-weight: 800;

  @media (min-width: 961px) {
    font-size: 36px;
  }
}

.welcome__subtitle {
  font-size: $base-font-size;
  margin-bottom: 20px;
}

.welcome__actions {
  display: inline-block;
  text-align: center;
}

.welcome__img {
  display: block;
  margin: 40px auto 0;
  max-width: 80%;

  @media (min-width: 961px) {
    float: right;
    margin-top: 0;
    max-width: 100%;
  }
}
</style>
